export { default } from './Hero';



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/homepage/components/Hero/index.ts